/**
 * Doofinder Cart Integration for Shopify Refresh Theme - Version 2.1
 * Fixes empty cart population and URL type errors
 * 
 * Installation:
 * 1. Go to Online Store > Themes > Edit Code
 * 2. In Assets folder, replace existing or create: doofinder-cart-fix-v2.js
 * 3. In Layout > theme.liquid, add before </body>:
 *    <script src="{{ 'doofinder-cart-fix-v2.js' | asset_url }}" defer></script>
 */

(function() {
  'use strict';
  
  console.log('[Doofinder Integration] Loading cart drawer fix v2.1...');
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  function init() {
    console.log('[Doofinder Integration] Initializing...');
    
    // Primary Method: Listen for Doofinder's documented event
    setupDoofinderEventListener();
    
    // Backup Methods
    interceptFetchRequests();
    monitorCartButtons();
    
    // Verify cart elements exist
    verifyCartElements();
  }
  
  /**
   * Primary Method: Listen for Doofinder's official cart.add event
   */
  function setupDoofinderEventListener() {
    // Main Doofinder event from their documentation
    document.addEventListener('doofinder.cart.add', function(event) {
      console.log('[Doofinder Integration] Caught doofinder.cart.add event', event.detail);
      
      const { item_id, amount } = event.detail || {};
      

    });
    
    // Also listen for alternative event names Doofinder might use
    const alternativeEvents = [
      'doofinder:add_to_cart:success',
      'doofinder:cart:added',
      'df:cart:add',
      'df:add_to_cart:success'
    ];
    
    alternativeEvents.forEach(eventName => {
      document.addEventListener(eventName, function(event) {
        console.log(`[Doofinder Integration] Caught ${eventName}`, event.detail);
        // Wait a moment for cart to update
        setTimeout(refreshAndOpenDrawer, 300);
      });
    });
  }
  
  /**
   * Add item to cart via Shopify API and open drawer
   */
  function addToCartAndOpenDrawer(variantId, quantity) {
    console.log(`[Doofinder Integration] Adding variant ${variantId} to cart, quantity: ${quantity}`);
    
    const formData = {
      'id': variantId,
      'quantity': quantity
    };
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(item => {
      console.log('[Doofinder Integration] Item added to cart:', item);
      // Add delay to ensure cart is updated
      setTimeout(refreshAndOpenDrawer, 200);
    })
    .catch(error => {
      console.error('[Doofinder Integration] Error adding to cart:', error);
      // Still try to refresh and open drawer
      setTimeout(refreshAndOpenDrawer, 200);
    });
  }
  
  /**
   * Refresh cart sections and open drawer
   * Fixed to handle empty cart state properly
   */
  function refreshAndOpenDrawer() {
    console.log('[Doofinder Integration] Refreshing cart and opening drawer...');
    
    // First fetch the current cart to ensure we have items
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        console.log('[Doofinder Integration] Current cart:', cart);
        
        // Now fetch updated sections
        return fetch('/cart?sections=cart-drawer,cart-icon-bubble');
      })
      .then(response => response.json())
      .then(sections => {
        console.log('[Doofinder Integration] Got updated sections');
        
        // Get cart drawer element
        const cartDrawer = document.querySelector('cart-drawer');
        
        if (cartDrawer) {
          // Check if drawer is empty and remove empty class if needed
          const drawerInner = cartDrawer.querySelector('.drawer__inner');
          if (drawerInner && drawerInner.classList.contains('is-empty')) {
            drawerInner.classList.remove('is-empty');
          }
          
          // Use renderContents method if available
          if (typeof cartDrawer.renderContents === 'function') {
            console.log('[Doofinder Integration] Using renderContents method');
            cartDrawer.renderContents({
              sections: sections,
              id: 'doofinder-cart-update'
            });
          } else {
            // Manual update and open
            console.log('[Doofinder Integration] Manual update and open');
            
            // Update drawer HTML
            if (sections['cart-drawer']) {
              const drawerElement = document.querySelector('#CartDrawer');
              if (drawerElement) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
                const newContent = doc.querySelector('#CartDrawer');
                if (newContent) {
                  drawerElement.innerHTML = newContent.innerHTML;
                }
              }
            }
            
            // Update cart icon
            if (sections['cart-icon-bubble']) {
              const iconBubble = document.querySelector('#shopify-section-cart-icon-bubble');
              if (iconBubble) {
                iconBubble.innerHTML = sections['cart-icon-bubble'];
              }
            }
            
            // Open the drawer
            if (typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            } else {
              cartDrawer.classList.add('animate', 'active');
              document.body.classList.add('overflow-hidden');
            }
          }
        } else {
          console.warn('[Doofinder Integration] Cart drawer element not found!');
          // Try clicking cart icon as fallback
          clickCartIcon();
        }
        
        // Dispatch events for other listeners
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(error => {
        console.error('[Doofinder Integration] Error fetching sections:', error);
        // Try to open drawer anyway
        openCartDrawerDirectly();
      });
  }
  
  /**
   * Direct method to open cart drawer
   */
  function openCartDrawerDirectly() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      // Remove empty state class if present
      const drawerInner = cartDrawer.querySelector('.drawer__inner');
      if (drawerInner && drawerInner.classList.contains('is-empty')) {
        drawerInner.classList.remove('is-empty');
      }
      
      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      } else {
        cartDrawer.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
      }
    } else {
      clickCartIcon();
    }
  }
  
  /**
   * Click cart icon as fallback
   */
  function clickCartIcon() {
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (cartIcon) {
      console.log('[Doofinder Integration] Clicking cart icon');
      cartIcon.click();
    }
  }
  
  /**
   * Backup Method: Intercept fetch requests to cart endpoints
   * FIXED: Properly handle different URL types
   */
  function interceptFetchRequests() {
    const originalFetch = window.fetch;
    
    window.fetch = function(...args) {
      const [resource] = args;
      
      // Handle different types of URL inputs
      let url = '';
      if (typeof resource === 'string') {
        url = resource;
      } else if (resource instanceof Request) {
        url = resource.url;
      } else if (resource instanceof URL) {
        url = resource.href;
      }
      
      // Check if this is a cart request
      if (url && typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change'))) {
        return originalFetch.apply(this, args).then(response => {
          if (response.ok) {
            console.log('[Doofinder Integration] Intercepted cart update via fetch');
            
            // Check if this might be from Doofinder
            const isDoofinderActive = document.querySelector('.doofinder-layer.df-active') || 
                                      document.querySelector('[class*="doofinder"]');
            
            if (isDoofinderActive) {
              // Wait for cart to be updated, then refresh and open
              setTimeout(refreshAndOpenDrawer, 500);
            }
          }
          return response;
        });
      }
      
      return originalFetch.apply(this, args);
    };
  }
  
  /**
   * Backup Method: Monitor clicks on Doofinder cart buttons
   */
  function monitorCartButtons() {
    document.addEventListener('click', function(event) {
      const target = event.target;
      
      // Check for Doofinder cart button patterns
      const isDoofinderButton = 
        target.classList.contains('df-add-to-cart') ||
        target.classList.contains('doofinder-add-to-cart') ||
        target.closest('.df-card__add-to-cart') ||
        target.closest('[data-doofinder-add-to-cart]') ||
        target.closest('[class*="df-"][class*="cart"]') ||
        (target.textContent && target.textContent.includes('Add') && 
         target.closest('[class*="doofinder"]'));
      
      if (isDoofinderButton) {
        console.log('[Doofinder Integration] Detected click on Doofinder button');
        // Wait longer for cart to update when starting from empty
        setTimeout(refreshAndOpenDrawer, 800);
      }
    }, true); // Use capture phase
  }
  
  /**
   * Verify cart elements exist and log status
   */
  function verifyCartElements() {
    const cartDrawer = document.querySelector('cart-drawer');
    const cartIcon = document.querySelector('#cart-icon-bubble');
    const drawerInner = document.querySelector('#CartDrawer');
    
    console.log('[Doofinder Integration] Verification:');
    console.log('- Cart drawer element:', !!cartDrawer);
    console.log('- Cart drawer has open method:', cartDrawer && typeof cartDrawer.open === 'function');
    console.log('- Cart drawer has renderContents:', cartDrawer && typeof cartDrawer.renderContents === 'function');
    console.log('- Cart icon bubble:', !!cartIcon);
    console.log('- Cart drawer inner:', !!drawerInner);
  }
  
  /**
   * Public function for manual testing
   */
  window.testDoofinderCart = function() {
    console.log('[Doofinder Integration] Manual test triggered');
    refreshAndOpenDrawer();
  };
  
  /**
   * Force refresh cart from server
   */
  window.forceRefreshCart = function() {
    console.log('[Doofinder Integration] Force refreshing cart...');
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        console.log('Cart contents:', cart);
        if (cart.item_count > 0) {
          refreshAndOpenDrawer();
        } else {
          console.log('Cart is empty');
        }
      });
  };
  
  /**
   * Simulate Doofinder event for testing
   */
  window.simulateDoofinderAdd = function(variantId = '12345', quantity = 1) {
    console.log('[Doofinder Integration] Simulating Doofinder add to cart');
    const event = new CustomEvent('doofinder.cart.add', {
      detail: {
        item_id: variantId,
        amount: quantity
      }
    });
    document.dispatchEvent(event);
  };
  
  console.log('[Doofinder Integration] Ready v2.1! Use testDoofinderCart() to test manually.');
  
})();

/**
 * TESTING COMMANDS
 * Run these in browser console:
 * 
 * 1. Test cart drawer opening:
 *    testDoofinderCart()
 * 
 * 2. Force refresh cart:
 *    forceRefreshCart()
 * 
 * 3. Simulate Doofinder add to cart:
 *    simulateDoofinderAdd('VARIANT_ID', 1)
 */
